import React from 'react';
import { Typography, Paper, Box } from '@mui/material';

const Dashboard = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1">
          Welcome to Sentinel! This is your dashboard where you can monitor your application's health and performance.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Dashboard;